import moment from 'moment';
import HttpFactory from '@/mixins/http.factory';
import TagsInput from '@/components/Inputs/TagsInput'
import { Select, Option } from 'element-ui'
import HtmlEditor from '@/components/Inputs/HtmlEditor'
import { mapState, mapActions,mapGetters } from 'vuex'
export default {
	name:'create-work-item',
	mixins:[HttpFactory],
	data () {
		return {
			htmlMessage:null,
			data:null,
			ticket_fields:[],
			fieldMapping:[],
			devOpsTenants:[],
			devOpsProjects:[],
            devOpsProjectData:{
                workItemTypes:[],
                nodesList:[],
                fieldsList:[],
                usersList:[],
                customFields:[],
            },
			showTags:false,
            editor_reproSteps_Obj:null,
            editor_description_Obj:null,
            createItemData:{attachments:[],files:[],fields:{},relations:{}},
			severityValues: ["1 - Critical","2 - High","3 - Medium","4 - Low"],
			priorityValues: [1, 2, 3, 4],
			isResolutionField: false,
			isAcptCriteriaField: false,
			isSystemInfoField: false,
			devOpsTenant:''
		}
	},
	computed:{
		//...mapState('zendesk',['zdTicket_fields'])//no need yet
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			//var count=0;
			modalClient.on('send_data_to_modal', (data) => {
				if (data.ticket.id == _self.$route.params.zdTicketId) {
					parentClient = modalClient.instance(data.parentClientGuid)
					_self.zendeskInfo = data;
					_self.workItemFields(_self.zendeskInfo.userInfo.allowMultiTenant?_self.zendeskInfo.userInfo.defaultTenant:null);
				}
				// _self.zendeskInfo = data;
				// if(_self.$route.params.zdTicketId)_self.zendeskInfo.ticket.id = _self.$route.params.zdTicketId;
				// count++;
				// if(count==1){
				// 	_self.workItemFields();
				// }
			});
		},
		initDropzone(data){
			const _self=this;
			if (!data || !data.userInfo || !data.userInfo.uploadFiles) return;
			data.credentials.devOpsTenant = _self.devOpsTenant;
			_self.fn().initDropzone('div.dropzone',data.credentials,'devops',function(error,response){
				_self.fn().clearMessage();
				if(error){
					_self.userMsg={show:true,type:'danger',list:[response?response:error]}
					return;
				}
				_self.createItemData.files=_self.createItemData.files.concat(response);
			});
		},
		removeFile(file){
			const _self=this;
			_self.createItemData.files=_self.createItemData.files.filter(d=>d.id!=file.id);
		},
		initJSTree(devOpsProjectData){
			let _self=this;
			if(_self.zendeskInfo && _self.zendeskInfo.userInfo && _self.zendeskInfo.userInfo.allowNodes){
			
				_self.fn().createJSTree('area_jstree',function(selectedObj){
					let selPath=selectedObj.path.replace('\\Area\\','\\'); //`${_self.createItemData.project.name}\\${selectedObj.text}`;
					//let selPath = selectedObj.path;
					//selPath=selPath.startsWith('\\')?selPath.substr(1,selPath.length-1):selPath;
					selPath=_self.fn().handleTfsAreaIteration(selPath,'Area',_self.zendeskInfo.userInfo);
					_self.createItemData.fields['System.AreaPath']=selPath;

				});
				_self.fn().createJSTree('iterations_jstree',function(selectedObj){
					let selPath=selectedObj.path.replace('\\Iteration\\','\\');//`${_self.createItemData.project.name}\\${selectedObj.text}`;
					//let selPath = selectedObj.path;
					//selPath=selPath.startsWith('\\')?selPath.substr(1,selPath.length-1):selPath;
					selPath=_self.fn().handleTfsAreaIteration(selPath,'Iteration',_self.zendeskInfo.userInfo);
					_self.createItemData.fields['System.IterationPath']=selPath;
				});

				_self.fn().updateJSTreeData('area_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='area'));
				_self.fn().updateJSTreeData('iterations_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='iteration'));
			}
		},
		async initCreateItemData(data,projectId){
			let _self=this;
			let project;
			if(projectId){
				project=_self.devOpsProjects.find(d=>d.id==projectId);
			}

			let reproSteps = _self.createItemData.fields['Microsoft.VSTS.TCM.ReproSteps'];
			_self.createItemData.fields={
				//'System.Title': data.ticket.subject,
				'System.Title': `${_self.zendeskInfo.ticket.organization.name} - ${data.ticket.subject} - (${_self.zendeskInfo.ticket.id})`,
			};
			if (reproSteps)_self.createItemData.fields['Microsoft.VSTS.TCM.ReproSteps'] = reproSteps;
			
			let comments=_self.zendeskInfo.ticket.comments;
			if(comments){
				let description_html=comments && comments.length>0?comments[comments.length-1].value:_self.zendeskInfo.ticket.description;
				_self.createItemData.fields['System.Description']=description_html;
			}
			_self.createItemData.hdTicketId=data.hdTicketId?data.hdTicketId:data.ticket.id;
			_self.createItemData.fields['System.TeamProject']=project?project.name:'';
			//_self.createItemData.fields['System.Title']=data.ticket.subject;
			//console.log('zendesk info',data);
			_self.createItemData.fields['Microsoft.VSTS.Common.Priority']=data.ticket.priority>0?data.ticket.priority:_self.handlePrioritySet(data.ticket.priority);
			_self.createItemData.fields['System.AssignedTo']='';
			_self.createItemData.fields['System.WorkItemType']='';
			_self.createItemData.fields['Microsoft.VSTS.Common.Severity']='';

			let defaultTags='';
			if(_self.zendeskInfo.userInfo.allowTags
				&& _self.zendeskInfo.userInfo.allowHDTags){
				defaultTags=data.ticket.tags?data.ticket.tags:[];
				defaultTags=defaultTags.length>0?defaultTags.join(';'):'';
			}
			
			
			_self.createItemData.fields['System.Tags']=defaultTags;
			_self.createItemData.fields['System.TagsArr'] =_self.createItemData.fields['System.Tags']?_self.createItemData.fields['System.Tags'].split(';'):[];
			_self.showTags=true;

			//boolean
			await _self.mapFrontEndFields();

		},
		handlePrioritySet(priority){
			let intPriority='';
			switch(priority){
				case 'low':
					intPriority=4;
					break;
				case 'normal':
					intPriority=3;
					break;
				case 'high':
					intPriority=2;
					break;
				case 'urgent':
					intPriority=1;
					break;
			}
			return intPriority;
		},
		onDateChanged(date,el) {
			let _self = this;
			let referenceName=el.target.getAttribute('referenceName');
			_self.createItemData.fields[referenceName]=date?_self.apiDateValue(date):null;
		},
		htmlEditorChange(data){
			const _self=this;
			_self.createItemData.fields[data.referenceName]=data.htmlContent?data.htmlContent:null;
		},
		formatDateValue(date){
			if(!date) return null;
			return moment(date).format('MM/DD/YYYY');
		},
		apiDateValue(dateObj){
			let _self=this;
			let date=_self.formatDateValue(dateObj);
			//return date;
			if(!date) return null;
			
			var currentDate = new Date();
			var newDate= (new Date(`${date} `+currentDate.toLocaleTimeString()));
			newDate.setMinutes(newDate.getMinutes()+(currentDate.getTimezoneOffset()*-1));
			return newDate.toISOString();
			//return newDate;
		},
		async  mapFrontEndFields(){
			const _self=this;
			if(_self.zendeskInfo.userInfo.mapFields=='front-end'
			||_self.zendeskInfo.userInfo.mapFields=='both'){
				let fieldMapping=_self.fieldMapping;
				if(fieldMapping.filter(d=>d.type=='ticket').length>0 &&
					_self.ticket_fields.length<=0){
					_self.ticket_fields=[];
					let ticketMapping=fieldMapping.filter(d=>d.type=='ticket' && d.hdIsCustomField===1);
					for(var i=0;i<ticketMapping.length;i++){
						//await this.$store.dispatch('zendesk/getZdTicket_fields')//no need it
						let action=`ticket.customField:custom_field_${ticketMapping[i].hdFieldMappingId}`;
						let ticket_field=await parentClient.get(action);
						_self.ticket_fields=_self.ticket_fields.concat({
							id:ticketMapping[i].hdFieldMappingId,
							value:ticket_field[action]
						});
					}
					
				}

				for(var i=0;i<fieldMapping.length;i++){
					if(fieldMapping[i].type=='organization'){
						if(_self.zendeskInfo.ticket.organization.organizationFields &&
							_self.zendeskInfo.ticket.organization.organizationFields[fieldMapping[i].hdFieldMappingId]){
							let orgSelectedVal=_self.zendeskInfo.ticket.organization.organizationFields[fieldMapping[i].hdFieldMappingId];
							if(fieldMapping[i].options && orgSelectedVal){
								let fieldOrgOptObj=fieldMapping[i].options.find(d=>d.hdOptionValue==orgSelectedVal);
								if(fieldOrgOptObj){
									_self.createItemData.fields[fieldMapping[i].devOpsFieldMappingId]=fieldOrgOptObj.devOpsOptionValue?fieldOrgOptObj.devOpsOptionValue:'';
								}
							}
							else if(orgSelectedVal){
								_self.createItemData.fields[fieldMapping[i].devOpsFieldMappingId]=orgSelectedVal;
							}
						}
					}else if(fieldMapping[i].type=='ticket' && fieldMapping[i].hdIsCustomField===1){
						let ticket_fieldObj=	_self.ticket_fields.find(d=>d.id==fieldMapping[i].hdFieldMappingId);
						if(fieldMapping[i].options && ticket_fieldObj){
							let fieldOptObj=fieldMapping[i].options.find(d=>d.hdOptionValue==ticket_fieldObj.value);
							if(fieldOptObj){
								_self.createItemData.fields[fieldMapping[i].devOpsFieldMappingId]=fieldOptObj.devOpsOptionValue?fieldOptObj.devOpsOptionValue:'';
							}
						}
						else if(ticket_fieldObj){
							_self.createItemData.fields[fieldMapping[i].devOpsFieldMappingId]=ticket_fieldObj.value?ticket_fieldObj.value:'';
						}
					}else if(fieldMapping[i].type=='ticket' && fieldMapping[i].hdIsCustomField===0){
						let fieldVal=_self.zendeskInfo.ticket[fieldMapping[i].hdFieldType]?_self.zendeskInfo.ticket[fieldMapping[i].hdFieldType]:_self.zendeskInfo.ticket[fieldMapping[i].hdFieldMappingId]
						let fieldOpt=fieldMapping[i].options.find(d=>d.hdOptionValue==fieldVal);
						if(fieldOpt){
							_self.createItemData.fields[fieldMapping[i].devOpsFieldMappingId]=fieldOpt.devOpsOptionValue?fieldOpt.devOpsOptionValue:'';
						}
					}
				}
			}
		},
		async autoMapFieldsFn(devOpsProjectData) {
			const _self = this;
			let autoMapFields = _self.zendeskInfo.userInfo.autoMapFields;
			if (!autoMapFields) return;
			
			//sample format
			// {
			// 	hdFieldId:devOpsFieldId
			// }
			//{"6368859474705":"Client","360020210397":"Dropdown Int"}
			let isJson = _self.fn().isJsonString(autoMapFields);
			
			let ticket_custom_fields; let resp_ticketFields;
			if (isJson || autoMapFields == 'All' || autoMapFields == 'Ticket') {
				let resp_ticket = await parentClient.request({
					url: `/api/v2/tickets/${_self.zendeskInfo.ticket.id}.json`,
					type: 'GET',
					dataType: 'json'
				});
				ticket_custom_fields = resp_ticket.ticket.custom_fields.filter(d => d.value != null);

				if (!ticket_custom_fields || !Array.isArray(ticket_custom_fields) || ticket_custom_fields.length <= 0) return;
				resp_ticketFields = await parentClient.request({
					url: '/api/v2/ticket_fields.json',
					type: 'GET',
					dataType: 'json'
				});
				if (!resp_ticketFields || !resp_ticketFields.ticket_fields || !Array.isArray(resp_ticketFields.ticket_fields)) return;
			}

			if (isJson) {
				let autoMapFieldsJson = JSON.parse(autoMapFields);
				autoMapFieldsJson = (Array.isArray(autoMapFieldsJson) && autoMapFieldsJson.length > 0) ? autoMapFieldsJson[0] : autoMapFieldsJson;
				let fieldsToMapJson=[];
					
				for (var key1 in autoMapFieldsJson) {
					let field = ticket_custom_fields.find(d => d.id == key1);
					if (field) { field.devOpsFieldName = autoMapFieldsJson[key1]; fieldsToMapJson.push(field); }
				}
				ticket_custom_fields = fieldsToMapJson;
			}
			if (autoMapFields == 'All' || autoMapFields == 'Ticket' || isJson ) {
				for (var i = 0; i < ticket_custom_fields.length; i++) {
					let ticket_field = resp_ticketFields.ticket_fields.find(d => d.id == ticket_custom_fields[i].id);
					
					if (ticket_field) {
						let devOpsField;
						if (isJson) devOpsField = devOpsProjectData.customFields.find(d => d.name == ticket_custom_fields[i].devOpsFieldName);
						else devOpsField = devOpsProjectData.customFields.find(d => d.name == ticket_field.title);
						if (devOpsField) {
							var isAllowed = true;
							if (devOpsField.isPicklist || devOpsField.isIdentity) {
								//verify if the option is there inv the field or not
								isAllowed = devOpsField.allowedValues.find(d => d == ticket_custom_fields[i].value) ? true : false;
							}
							if (isAllowed) _self.createItemData.fields[devOpsField.referenceName] = ticket_custom_fields[i].value ? ticket_custom_fields[i].value : '';
						}
					}
				}
			}

			
			if (autoMapFields == 'All' || autoMapFields == 'Organization') {
				let resp_organization = await parentClient.request({
					url: `/api/v2/organizations/${_self.zendeskInfo.ticket.organization.id}.json`,
					type: 'GET',
					dataType: 'json'
				});
				let ticket_orgfields = _self.fn().removeNulls(resp_organization.organization.organization_fields);


				if (ticket_orgfields && !_self.fn().isJSONEmpty(ticket_orgfields)) {
					let resp_orgFields = await parentClient.request({
						url: '/api/v2/organization_fields.json',
						type: 'GET',
						dataType: 'json'
					});
					if (resp_orgFields && resp_orgFields.organization_fields && Array.isArray(resp_orgFields.organization_fields)) {
						for (var key in ticket_orgfields) {
							let org_field = resp_orgFields.organization_fields.find(d => d.key == key);
							
							if (org_field) {
								let devOpsField = devOpsProjectData.customFields.find(d => d.name == org_field.title);
								if (devOpsField) {
									var isAllowed = true;
									if (devOpsField.isPicklist || devOpsField.isIdentity) {
										//verify if the option is there inv the field or not
										isAllowed = devOpsField.allowedValues.find(d => d == ticket_orgfields[key]) ? true : false;
									}
									if (isAllowed) { _self.createItemData.fields[devOpsField.referenceName] = ticket_orgfields[key] ? ticket_orgfields[key] : ''; }

								}
							}
						}
					}
				}
			}
		},
		setDefaultTenantFn(devOpsTenants) {
			let _self = this;
			if (devOpsTenants && devOpsTenants.length > 0) {
				
				let devOpsTenantData = devOpsTenants.find(d=>d.organizationName==_self.zendeskInfo.userInfo.defaultTenant);
				
				if (devOpsTenantData) _self.createItemData.devOpsTenant = devOpsTenantData.organizationName;
				else _self.createItemData.devOpsTenant = devOpsTenants[0].organizationName;
			}
		},
		setDefaultProjectFn(devOpsProjects) {
			let _self = this;
			if (devOpsProjects && devOpsProjects.length > 0) {
				
				let defaultProjectData = devOpsProjects.find(d=>d.name==_self.zendeskInfo.userInfo.defaultProject);
				
				if (defaultProjectData) _self.createItemData.projectId = defaultProjectData.id;
				else _self.createItemData.projectId = devOpsProjects[0].id;
			}
		},
		workItemFields(devOpsTenant){
			let _self = this;
			_self.devOpsTenant = devOpsTenant;
			_self.devOpsProjectsFn(devOpsTenant, function (projectsResp) {
				if (projectsResp.data.organizations) {
					_self.devOpsTenants = projectsResp.data.organizations;
				}
				
				_self.fieldMapping=projectsResp.data.fieldMapping;
				let devOpsProjects=projectsResp.data.Data.value;
				_self.htmlMessage=projectsResp.data.htmlMessage;
				if(devOpsProjects && devOpsProjects.length>0){
					_self.setDefaultProjectFn(devOpsProjects);
					_self.getDevOpsProjectData(function(devOpsProjectData){
						_self.devOpsProjects=devOpsProjects;
						_self.fn().showLoader(false);
						setTimeout(function(){_self.initDropzone(_self.zendeskInfo);},500);
						setTimeout(function(){
							_self.initJSTree(devOpsProjectData);
							// _self.fn().createHtmlEditor('editor_reproSteps','editor_reproSteps',null,function(editorObj,error){
							// 	_self.editor_reproSteps_Obj=editorObj?editorObj:null;
							// });
							let comments=_self.zendeskInfo.ticket.comments;
							if(comments){
								//let description_html=comments && comments.length>0?comments[comments.length-1].value:_self.zendeskInfo.ticket.description;
								//_self.createItemData.fields['System.Description']=description_html;
								// _self.fn().createHtmlEditor('editor_description','editor_description',description_html,function(editorObj,error){
								// 	_self.editor_description_Obj=editorObj?editorObj:null;
								// });
							}
						},1000);
					})
				}
				
			});
		},
		isResolutionOrAcptCriteriaFn(){
			const _self=this;
			let isFieldAvl=false;
			try{
				if(_self.devOpsProjectData.fieldsList &&
					_self.devOpsProjectData.fieldsList.value){
						let field=_self.devOpsProjectData.fieldsList.value.find(d=>d.referenceName=='Microsoft.VSTS.Common.AcceptanceCriteria'
						|| d.referenceName=='Microsoft.VSTS.Common.Resolution');
						
					isFieldAvl=(field && field!=null)?true:false;
				}
			}catch(ex){
				console.log('isResolutionOrAcptCriteria',ex);
			}
			_self.isResolutionOrAcptCriteria=isFieldAvl;
			return isFieldAvl;
		},
		isResolutionOrAcptCriteriaFn(){
			const _self = this;
			_self.isAcptCriteriaField=false;
			_self.isResolutionField = false;
			_self.isSystemInfoField=false;
			try{
				if(_self.devOpsProjectData.fieldsList && _self.devOpsProjectData.fieldsList.value){
						
					let field=_self.devOpsProjectData.fieldsList.value.find(d=>d.referenceName=='Microsoft.VSTS.Common.AcceptanceCriteria');
                    _self.isAcptCriteriaField=(field && field!=null)?true:false;

                    field=_self.devOpsProjectData.fieldsList.value.find(d=>d.referenceName=='Microsoft.VSTS.Common.Resolution');
					_self.isResolutionField = (field && field != null) ? true : false;
					
					field=_self.devOpsProjectData.fieldsList.value.find(d=>d.referenceName=='Microsoft.VSTS.TCM.SystemInfo');
                    _self.isSystemInfoField=(field && field!=null)?true:false;
				}
			}catch(ex){
				console.log('isResolutionOrAcptCriteria',ex);
			}
		},
		resetPageData() {
			let _self = this;
			_self.devOpsProjects = [];
				_self.devOpsProjectData = {
					workItemTypes: [],
					nodesList: [],
					fieldsList: [],
					usersList: [],
					customFields: [],
				};
			_self.createItemData = { attachments: [], files: [], fields: {}, relations: {} };
		},
		async getDevOpsTenantData(cb){
			let _self = this;
			_self.resetPageData();
			//setDefaultProjectFn
			_self.workItemFields(_self.devOpsTenant);
		},
		async getDevOpsProjectData(cb){
			let _self=this;
			let projectId=_self.createItemData.projectId;
			await _self.initCreateItemData(_self.zendeskInfo,projectId);
			_self.devOpsProjectDataFn(projectId,_self.devOpsTenant,async function(data){
				let devOpsProjectData=data.data.Data;
				//exclude System and Microsoft default fields from Custom Fields list
				// also exclude WEF_61C448B651F645D5883FCE6D92119478_Column
				devOpsProjectData.customFields=devOpsProjectData.fieldsList.value.filter(d=>d.referenceName 
					&& d.referenceName.indexOf('System.')<0 
					&& d.referenceName.indexOf('Microsoft.')<0
					&& d.referenceName.indexOf('WEF_')!=0);
				await _self.initFieldsDefaultVal(devOpsProjectData.fieldsList.value);
				await _self.autoMapFieldsFn(devOpsProjectData);
				_self.initPriortySeverity(devOpsProjectData.fieldsList.value);
				_self.devOpsProjectData=devOpsProjectData;
				_self.isResolutionOrAcptCriteriaFn();
				if(cb) cb(devOpsProjectData);
				else{
					_self.fn().showLoader(false);
					_self.fn().updateJSTreeData('area_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='area'));
					_self.fn().updateJSTreeData('iterations_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='iteration'));
					//setTimeout(function(){_self.applyDatePicker();},1000);
				}
			},function(err){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the azure devops does not have required permissions.',
					'Can you please create azure devops token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000451379-how-to-create-azure-devops-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			});
		},
		async initFieldsDefaultVal(fieldsList){
			const _self=this;
			let defaultValFields=fieldsList.filter(d=>d.defaultValue!==undefined || d.type=='boolean');
			if(defaultValFields){
				for(var i=0;i<defaultValFields.length;i++){
					if(defaultValFields[i].defaultValue){
						_self.createItemData.fields[defaultValFields[i].referenceName]=defaultValFields[i].defaultValue;
					}
					else if(defaultValFields[i].type=='boolean'){
						_self.createItemData.fields[defaultValFields[i].referenceName]=false;
					}
				}
			}

			let pickListFields=fieldsList.filter(d=>d.isPicklist || d.isIdentity);
			for(var i=0;i<pickListFields.length;i++){
				_self.createItemData.fields[pickListFields[i].referenceName]=_self.createItemData.fields[pickListFields[i].referenceName]?_self.createItemData.fields[pickListFields[i].referenceName]:'';
			}
		},
		initPriortySeverity(fieldsList) {
			const _self=this;
			let sv = fieldsList.find(d => d.referenceName == 'Microsoft.VSTS.Common.Severity');
			let svAllowedValues = ["1 - Critical", "2 - High", "3 - Medium", "4 - Low"];
			if (sv && sv.allowedValues) {
				svAllowedValues = sv.allowedValues;
			}
			_self.severityValues = svAllowedValues;

			let pr = fieldsList.find(d => d.referenceName == 'Microsoft.VSTS.Common.Priority');
			let prAllowedValues = [1,2,3,4];
			if (pr && pr.allowedValues) {
				prAllowedValues = pr.allowedValues;
			}
			_self.priorityValues = prAllowedValues;
		},
		async validateForm(){
			let isValid=await this.$validator.validateAll();
			
			if(!isValid){
				this.userMsg={show:true,type:'danger',list:[`Please scroll up and fill all required fields.`]}
			}
			return isValid;
		},
		//create init
		devOpsUsersFn:function(devOpsTenant,successCb,errorCb){
            var _self=this;
			let data = {};
			if (devOpsTenant) data.devOpsTenant = devOpsTenant;
            var url = `dev-ops/users`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
		},
		devOpsTenantDataFn:function(devOpsTenantId,successCb,errorCb){
            var _self=this;
            var url = `dev-ops/tenants/${devOpsTenantId}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
        devOpsProjectsFn:function(devOpsTenant,successCb,errorCb){
			var _self = this;
			let data = {};
			if (devOpsTenant) data.devOpsTenant = devOpsTenant;
            var url = `dev-ops/projects`;
            _self.fn().clearMessage();
			_self.postServerFn(url,data,successCb,errorCb);
        },
        devOpsProjectDataFn:function(projectId,devOpsTenant,successCb,errorCb){
            var _self=this;
			let data = {};
			if (devOpsTenant) data.devOpsTenant = devOpsTenant;
            var url = `dev-ops/projects/${projectId}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,data,successCb,errorCb);
        },
		createWorkItemFn(){
			let _self=this;
			_self.fn().clearMessage();
			if(_self.editor_reproSteps_Obj)
				_self.createItemData.fields['Microsoft.VSTS.TCM.ReproSteps']=_self.fn().getHtmlEditorContent(_self.editor_reproSteps_Obj);

			if(_self.editor_description_Obj)
				_self.createItemData.fields['System.Description']=_self.fn().getHtmlEditorContent(_self.editor_description_Obj);
			
			_self.createItemData.fields['System.Tags']=_self.createItemData.fields['System.TagsArr']?_self.createItemData.fields['System.TagsArr'].join(';'):'';
			let data={..._self.createItemData};
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			data.project=_self.devOpsProjects.find(d=>d.id==data.projectId);
			if (_self.zendeskInfo.userInfo.allowMultiTenant) data.devOpsTenant = _self.devOpsTenant;

			let newFields={};
			for(var key in data.fields){
				if(data.fields[key]){
					newFields[key]=data.fields[key];
				}
			}
			data.fields=newFields;
			
			delete data.fields['System.TagsArr'];
			let url=`dev-ops/workitems/create`;
			_self.postServerFn(url,data,function(response){
				_self.fn().showLoader(false);
				let userMsg;
				if(response.data.Success){
					userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Work item created Successfully`]}
					_self.sendDataToParent(response.data);
				}else{
					_self.showTags=false;
					_self.createItemData.fields['System.TagsArr']=_self.createItemData.fields['System.Tags']?_self.createItemData.fields['System.Tags'].split(';'):[];
					setTimeout(function(){_self.showTags=true;},1000);
					userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`Work item creation failed.`]}
				}
				_self.userMsg=userMsg;
			},function(error){ 
				_self.fn().showLoader(false);
				_self.showTags=false;
				_self.createItemData.fields['System.TagsArr']=_self.createItemData.fields['System.Tags']?_self.createItemData.fields['System.Tags'].split(';'):[];
				setTimeout(function(){_self.showTags=true;},1000);
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		},
		postServerFn(url,data,successCb,errorCb){
			let _self=this;
			data=data?data:{};
			data.auth=_self.zendeskInfo.credentials;
			_self.post(url,data).then(response=>{
				if(successCb) successCb(response);
			}).catch(error=>{
				if(errorCb) errorCb(error);
			});
		}
	},
	components:{HtmlEditor,TagsInput,[Select.name]: Select,[Option.name]: Option}
}

